// in src/posts.js
import React, { useState } from 'react';

import { List, Datagrid, TextField, DeleteButton, TextInput, Button, TopToolbar, NumberInput, ResourceContextProvider, useCreate, useRefresh, FormWithRedirect, SaveButton, useUpdate, useNotify, BooleanField, BooleanInput, FormDataConsumer, required, ReferenceInput, ReferenceField, SelectInput, useInput } from 'react-admin';import { useTranslate  } from '../common/language';

import Typography from '@mui/material/Typography';



import EditIcon from '@material-ui/icons/Edit';
import Grid from '@mui/material/Grid';
import IconContentAdd from '@material-ui/icons/Add';
import IconCancel from '@material-ui/icons/Cancel';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';

import RichTextInput from 'ra-input-rich-text';

import Box from '@material-ui/core/Box';
import FormControl from '@material-ui/core/FormControl';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormHelperText from '@material-ui/core/FormHelperText';
import FormLabel from '@material-ui/core/FormLabel';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';


import { validateMaxLength } from './../components/Validator';import { RichTextField } from './../components/RichTextField';

const AUDIENCE_TYPE_EVERYONE = 0;
const AUDIENCE_TYPE_SUBSCRIBERS = 1;
const AUDIENCE_TYPE_CODE = 2;
const AUDIENCE_TYPE_CONTACT_GROUP = 3;

const choicesAudienceTypes = translate => [
  { id: AUDIENCE_TYPE_EVERYONE, name: translate('tickets_groups.audience_type_0'), desc: translate('tickets_groups.audience_type_0_desc') },
  { id: AUDIENCE_TYPE_SUBSCRIBERS, name: translate('tickets_groups.audience_type_1'), desc: translate('tickets_groups.audience_type_1_desc') },
  { id: AUDIENCE_TYPE_CODE, name: translate('tickets_groups.audience_type_2'), desc: translate('tickets_groups.audience_type_2_desc') },
  { id: AUDIENCE_TYPE_CONTACT_GROUP, name: translate('tickets_groups.audience_type_3'), desc: translate('tickets_groups.audience_type_3_desc') },
];

const audienceTypeLabel = (translate, type) => translate('tickets_groups.audience_type_' + (type || AUDIENCE_TYPE_EVERYONE));

const AudienceTypeField = ({ record }) => {
  const translate = useTranslate();
  if (!record || Number(record.audience_type) !== AUDIENCE_TYPE_CONTACT_GROUP) {
    return <span>{record ? audienceTypeLabel(translate, record.audience_type) : ''}</span>;
  }

  return (
    <span>
      {audienceTypeLabel(translate, record.audience_type)}: <ReferenceField record={record} source="audience_groups_id" reference="groups" link={false}>
        <TextField source="name" />
      </ReferenceField>
    </span>
  );
};

const AudienceTypeInput = ({ source, label, validate }) => {
  const translate = useTranslate();
  const { id, input, meta, isRequired } = useInput({ source, validate });
  const inputError = meta.touched && (meta.error || meta.submitError);

  return (
    <FormControl component="fieldset" margin="dense" error={!!inputError} fullWidth>
      <FormLabel component="legend">{label}{isRequired ? ' *' : ''}</FormLabel>
      <RadioGroup
        id={id}
        value={input.value === null || input.value === undefined ? String(AUDIENCE_TYPE_EVERYONE) : String(input.value)}
        onChange={event => input.onChange(Number(event.target.value))}
      >
        {choicesAudienceTypes(translate).map(choice => (
          <FormControlLabel
            key={choice.id}
            value={String(choice.id)}
            control={<Radio color="primary" />}
            label={(
              <Box style={{ padding: '6px 0 10px 0' }}>
                <Typography variant="body2">{choice.name}</Typography>
                <Typography variant="caption" color="textSecondary">{choice.desc}</Typography>
              </Box>
            )}
          />
        ))}
      </RadioGroup>
      <FormHelperText>{inputError ? translate(inputError) : null}</FormHelperText>
    </FormControl>
  );
};

const AudienceConfigurationFields = ({ formData }) => {
  const translate = useTranslate();
  const audienceType = formData && formData.audience_type !== undefined && formData.audience_type !== null ? Number(formData.audience_type) : AUDIENCE_TYPE_EVERYONE;

  if (audienceType === AUDIENCE_TYPE_CODE) {
    return (
      <>
        <Grid item xs={12} md={3}>
          <NumberInput fullWidth source="audience_code_min_length" label={translate('tickets_groups.audience_code_min_length')} validate={[required()]} />
        </Grid>
        <Grid item xs={12} md={3}>
          <NumberInput fullWidth source="audience_code_max_length" label={translate('tickets_groups.audience_code_max_length')} validate={[required()]} />
        </Grid>
      </>
    );
  }

  if (audienceType === AUDIENCE_TYPE_CONTACT_GROUP) {
    return (
      <>
        <Grid item xs={12} md={8}>
          <ReferenceInput fullWidth label={translate('tickets_groups.audience_groups_id')} source="audience_groups_id" reference="groups" filter={{ associations_id: localStorage.getItem('associations_id') }} perPage={1000} sort={{ field: 'priority', order: 'ASC' }} validate={[required()]}>
            <SelectInput optionText="name" optionValue="id" resettable />
          </ReferenceInput>
        </Grid>
        <Grid item xs={12} md={4}>
          <NumberInput fullWidth source="audience_max_tickets_per_contact_session" label={translate('tickets_groups.audience_max_tickets_per_contact_session')} validate={[required()]} />
        </Grid>
      </>
    );
  }

  return null;
};

export const SettingsTicketsGroups = (props) => {
  const translate = useTranslate();    
    
  let strRedirect =  '/settings-tickets-groups';  
    
  return (
    <>
      <br/>
      <Typography variant="h5" className="grey8" align="center">
        {translate('tickets_groups.title')}              
      </Typography>
      <Box sx={{ bgcolor: 'background.paper', padding: '20px' }} className="settings_box" >
        <ResourceContextProvider value="tickets_groups">
          <List {...props} 
            basePath="/tickets_groups" 
            sort={{ field: 'priority', order: 'ASC' }} 
            actions={<ListActionsTicketsGroupsList/>}    
            filter={{ associations_id : localStorage.getItem('associations_id') }}  
            bulkActionButtons={false}  
            pagination={false}
            empty={<ListActionsTicketsGroupsList />} 
            fullWidth
          >        
            <Datagrid fullWidth>            
              <TextField source="name" label={translate('common.name')} sortable={false} />  
              <AudienceTypeField label={translate('tickets_groups.audience_type')} sortable={false} />
              <BooleanField source="apply_default" label={translate('tickets_groups.apply_default')} sortable={false}  />              
              <TicketsGroupsEditButton label="" />
              <DeleteButton undoable={false} redirect={strRedirect} label="" />
            </Datagrid>        
          </List>
        </ResourceContextProvider>
      </Box>
    </>
  );
};

const ListActionsTicketsGroupsList = (props) => {
  const translate = useTranslate(); 
  return (
    <TopToolbar>     
      <TicketsGroupsCreateButton />      
    </TopToolbar>
  );
};


const TicketsGroupsCreateButton = ({ ...props }) => {

  const [showDialog, setShowDialog] = useState(false);
    
  const notify = useNotify();
  const refresh = useRefresh();    
  const translate = useTranslate();  

  const [create, { loading }] = useCreate('tickets_groups');

  const handleClick = () => {
    setShowDialog(true);
  };

  const handleCloseClick = () => {
    setShowDialog(false);
  };

  const handleSubmit = async values => {
    create(            
      { payload: { data: values } },
      {
        onSuccess: ({ data }) => {
          setShowDialog(false);
          refresh();
        },
        onFailure: ( error ) => {
          notify( error.message , 'error');
        }
      }
    );
  };    

  return (
    <>            
      <Button onClick={handleClick} label={translate('tickets_groups.create')}>
        <IconContentAdd />                
      </Button>

      <Dialog
        fullWidth
        open={showDialog}
        onClose={handleCloseClick}
        aria-label={translate('tickets_groups.create')}
        className="dialog-md"
        maxWidth="lg"
      >
        <DialogTitle>{translate('tickets_groups.create')}</DialogTitle>

        <FormWithRedirect
          resource="tickets_groups"
          save={handleSubmit}
          initialValues={ { associations_id : localStorage.getItem('associations_id'), audience_type: AUDIENCE_TYPE_EVERYONE, audience_code_min_length: 1, audience_code_max_length: 20, audience_max_tickets_per_contact_session: 1 } }
          render={({
            handleSubmitWithRedirect,
            pristine,
            saving
          }) => (
            <>
              <FormContent />
              <DialogActions>
                <Button label="ra.action.cancel" onClick={handleCloseClick} disabled={loading} >
                  <IconCancel />
                </Button>
                <SaveButton
                  handleSubmitWithRedirect={
                    handleSubmitWithRedirect
                  }
                  pristine={pristine}
                  saving={saving}
                  disabled={loading}
                />
              </DialogActions>
            </>
          )}
        />
      </Dialog>
    </>
  );
};

const FormContent = (props) => {

  const translate = useTranslate(); 
  return (
    <DialogContent>
        <Grid container spacing={2}>
            <Grid item xs={9}>   
                <TextInput fullWidth source="name" label={translate('common.name')} validate={[validateMaxLength(255,translate('common.validation.maxLength'))]} />
            </Grid> 
            <Grid item xs={3}>   
                <NumberInput step={1} fullWidth source="priority" label={translate('common.priority')} />
            </Grid> 
            <Grid item xs={12}>   
                <RichTextInput source="description" validate={[validateMaxLength(1000,translate('common.validation.maxLength'))]} multiline />
            </Grid>             
            <FormDataConsumer>
              {({ formData }) => (
                <>
                  <Grid item xs={12}>   
                    <AudienceTypeInput source="audience_type" label={translate('tickets_groups.audience_type')} validate={[required()]} />
                  </Grid>
                  <AudienceConfigurationFields formData={formData} />
                </>
              )}
            </FormDataConsumer>
            <Grid item xs={12}>   
                <BooleanInput fullWidth source="apply_default" label={translate('tickets_groups.apply_default')} />
            </Grid> 
            <Grid item xs={5}>   
                <BooleanInput fullWidth source="require_check" label={translate('tickets_groups.require_check')} />
            </Grid> 
            <Grid item xs={7}>   
                <TextInput fullWidth source="require_check_message" label={translate('tickets_groups.require_check_message')} />
            </Grid> 
        </Grid>           
    </DialogContent>
  );
};

const TicketsGroupsEditButton = ({ ...props }) => {

  const [showDialog, setShowDialog] = useState(false);
    
  const notify = useNotify();
  const refresh = useRefresh();    
  const translate = useTranslate();  

  const [update, { loading, error }] = useUpdate();

  const handleClick = () => {
    setShowDialog(true);
  };

  const handleCloseClick = () => {
    setShowDialog(false);
  };

  const handleSubmit = async values => {
    update(
      { 
        type: 'update', 
        resource: 'tickets_groups', 
        payload : { id: values.id, data : values }
      },
      {
        onSuccess: ({ data }) => {
          setShowDialog(false);
          refresh();
        },
        onFailure: ( error ) => {
          notify(error.message, 'error');
        }
      }
    );
  };    

  return (
    <>
      <Button onClick={handleClick} label="" startIcon={<EditIcon />} />

      <Dialog
        fullWidth
        open={showDialog}
        onClose={handleCloseClick}
        aria-label={translate('tickets_groups.edit')}
        className="dialog-md"
        maxWidth="lg"
      >
        <DialogTitle>{translate('tickets_groups.edit')}</DialogTitle>

        <FormWithRedirect
          resource="tickets_groups"
          save={handleSubmit}
          initialValues={ { audience_code_min_length: 1, audience_code_max_length: 20, audience_max_tickets_per_contact_session: 1, ...props.record } }
          render={({
            handleSubmitWithRedirect,
            pristine,
            saving
          }) => (
            <>
              <FormContent />
              <DialogActions>
                <Button label="ra.action.cancel" onClick={handleCloseClick} disabled={loading} >
                  <IconCancel />
                </Button>
                <SaveButton
                  handleSubmitWithRedirect={
                    handleSubmitWithRedirect
                  }
                  pristine={pristine}
                  saving={saving}
                  disabled={loading}
                />
              </DialogActions>
            </>
          )}
        />
      </Dialog>
    </>
  );
};

